module.exports = __webpack_public_path__ + "8bfe3a5244d9f533b1543e319f813e91.pdf";